<template>
  <div class="d-flex flex-column align-center">
    <div>
      <v-badge
        :content="customerCountTemp"
        inline
      >
        <v-icon
          large
          right
        >
          {{ icons.mdiAccountOutline }}
        </v-icon>
      </v-badge>

      <div class="d-flex flex-column">
        <div>
          <v-btn
            icon
            :ripple="false"
            @click="countDown"
          >
            <v-icon>
              {{ icons.mdiMinus }}
            </v-icon>
          </v-btn>

          <v-btn
            icon
            :ripple="false"
            @click="countUp"
          >
            <v-icon>
              {{ icons.mdiPlus }}
            </v-icon>
          </v-btn>
        </div>

        <v-slide-y-transition>
          <div v-show="isChanging">
            <v-btn
              icon
              :ripple="false"
              color="primary"
              @click="updateCustomerCount"
            >
              <v-icon>
                {{ icons.mdiCheckCircleOutline }}
              </v-icon>
            </v-btn>

            <v-btn
              icon
              :ripple="false"
              color="error"
              @click="cancelChanging"
            >
              <v-icon>
                {{ icons.mdiCloseCircleOutline }}
              </v-icon>
            </v-btn>
          </div>
        </v-slide-y-transition>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref, onUnmounted, watch,
} from '@vue/composition-api'
import { clone } from 'lodash'
import {
  mdiAccountOutline,
  mdiPlus,
  mdiMinus,
  mdiCloseCircleOutline,
  mdiCheckCircleOutline,
} from '@mdi/js'

export default {
  props: {
    tableId: {
      type: [Number, String],
      validator: value => !Number.isNaN(Number(value)),
      required: true,
    },
    customerCount: {
      type: [Number, String],
      validator: value => !Number.isNaN(Number(value)),
      required: true,
    },
  },
  setup(props, { emit }) {
    const customerCountTemp = ref(clone(props.customerCount))
    const isChanging = ref(false)

    const changeCustomerCount = number => {
      isChanging.value = true

      if ((customerCountTemp.value + number) <= 0) return

      customerCountTemp.value += number
    }

    const countUp = () => {
      // isChanging.valueがfalseの時はemit('open-order-dialog')
      if (!isChanging.value) {
        emit('open-order-dialog')

        return
      }

      changeCustomerCount(1)
    }

    const countDown = () => {
      changeCustomerCount(-1)
    }

    const cancelChanging = () => {
      isChanging.value = false
      customerCountTemp.value = props.customerCount
    }

    const updateCustomerCount = () => {
      isChanging.value = false

      emit('updated-customer-count', customerCountTemp.value)
    }

    watch(() => props.customerCount, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        customerCountTemp.value = newVal
      }
    })

    onUnmounted(() => isChanging.value = false)

    return {
      customerCountTemp,
      isChanging,

      cancelChanging,
      updateCustomerCount,
      countUp,
      countDown,

      icons: {
        mdiAccountOutline,
        mdiPlus,
        mdiMinus,
        mdiCloseCircleOutline,
        mdiCheckCircleOutline,
      },
    }
  },
}
</script>
